module.exports = __webpack_public_path__ + "media/camera_shutter_01.707797a6.mp3";